import { render, staticRenderFns } from "./storesdata.vue?vue&type=template&id=2d7c179d&scoped=true&"
import script from "./storesdata.vue?vue&type=script&lang=js&"
export * from "./storesdata.vue?vue&type=script&lang=js&"
import style0 from "./storesdata.vue?vue&type=style&index=0&id=2d7c179d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7c179d",
  null
  
)

export default component.exports